<template id="modal-box-template">
    <transition name="modal">
        <div v-if="modalActive" @click.self="close()" class="test">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">

                        <div class="modal-header">
                            <slot name="header">
                                {{title}}
                            </slot>
                        </div>

                        <div class="modal-body">
                            <slot name="body">
                                default body
                            </slot>
                            <section>
                                <component :is="component" :content="JSON.stringify(componentData)"></component>
                            </section>
                        </div>

                        <div class="modal-footer pr-0">
                            <slot name="footer">
                                <button type="button" class="btn btn-secondary waves-effect waves-light"
                                        @click="close()"
                                        data-dismiss="modal">Close
                                </button>
                            </slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </transition>
</template>

<script>
	/**
	 <!--<button class="modal-default-button" @click="$emit('close')">-->
	 <!--OK-->
	 <!--</button>-->
	 *
	 *
	 <div id="app">
	 <button id="show-modal" @click="showModal = true">Show Modal</button>
	 <!-- use the modal component, pass in the prop -->
	 <modal v-if="showModal" @close="showModal = false">
	 <!--
	 you can use custom content here to overwrite
	 default content
	 -->
	 <h3 slot="header">custom header</h3>
	 </modal>
	 </div>
	 */
	// add imports here
	import {HUB} from '../../../../../../../resources/assets/js/config';

	export default {
		props: [],
		mounted() {
			this.$nextTick(function () {
				HUB.$on('set-modal-data', this.set);
				HUB.$on('open-modal', this.open);
			}.bind(this));
		},
		data() {
			return {
				title:'',
				modalActive: null,
                componentData:null
			}
		},
		computed: {},
		destroyed() {
			HUB.$off('set-modal-data', this.set);
			HUB.$off('open-modal', this.open);
		},
		methods: {
			close() {
				this.modalActive = false;
			},

			open() {
				this.modalActive = true;
			},

			set(data, component) {
//				console.log('data',data);
//				return;
//				this.data = data;
				this.title = data.title;
				this.componentData = data;
				this.component = component; // of course you could just pass the component through the method too...
                console.log('this.component',this.component);
			}
		}
	}
</script>
<style>
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 300px;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-default-button {
        float: right;
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
</style>



// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/notifications/modal.vue?1a74d705